<template>
  <div class="antv-chart-mini">
    <div class="chart-wrapper" :style="{ height: 46 }">
      <v-chart :force-fit="true" :height="height" :data="dataSource" :padding="[36, 0, 18, 0]">
        <v-tooltip />
        <v-smooth-area position="date*num" />
      </v-chart>
    </div>
  </div>
</template>

<script>
const tooltip = [
  'date*num',
  (x, y) => ({
    name: x,
    value: y
  })
]
const scale = [{
  dataKey: 'date',
  min: 2
}, {
  dataKey: 'num',
  title: '时间',
  min: 1,
  max: 22
}]

export default {
  name: 'MiniArea',
  props: {
    dataSource: {
      type: Array,
      default: []
    }
  },
  data () {
    return {
      tooltip,
      scale,
      height: 100
    }
  },
  mounted () {
    console.log('aaa', this.dataSource)
  }
}
</script>

<style lang="less" scoped>
  @import "chart";
</style>



// WEBPACK FOOTER //
// src/components/Charts/MiniArea.vue